import { useEffect, useState } from 'react';

import { useAuth } from 'js/contexts/AuthContext';
import { getUserPartner } from 'js/library/utils/API/auth/getUserPartner';
import cfac22 from 'js/library/utils/cfac22';
import { getStoredAuthData } from './authSession';

export async function getCurrentUserInfo(options = {}) {
  const authData = options.authData || getStoredAuthData();
  const userUId = authData?.userUId || authData?.uId || null;

  if (!userUId) {
    return null;
  }

  const userInfo = await getUserPartner({
    partnerId: cfac22('partnerId'),
    uid: userUId,
  });
  
  return userInfo;
}

export function getCurrentUserIdentifier() {
  return getStoredAuthData()?.userUId || null;
}

export function useCurrentUserInfo() {
  const { authState } = useAuth();
  const [state, setState] = useState({
    loading: true,
    userInfo: authState.currentUserInfo,
    error: null,
  });

  useEffect(() => {
    // Se tem currentUserInfo no contexto, usa ele
    if (authState.currentUserInfo) {
      setState({ loading: false, userInfo: authState.currentUserInfo, error: null });
      return;
    }

    // Se é guest, usa os dados do guest (resposta bruta)
    if (!authState.authData && authState.guestData) {
      setState({
        loading: false,
        userInfo: authState.guestData,
        error: null,
      });
      return;
    }

    // Se não tem authData, não está carregado ainda
    if (!authState.authData) {
      setState({ loading: true, userInfo: null, error: null });
      return;
    }

    // Se tem authData mas não tem currentUserInfo, está carregando
    setState({ loading: true, userInfo: null, error: null });
  }, [authState.authData, authState.currentUserInfo, authState.guestData]);

  return state;
}
